export default "__VITE_ASSET__DAOt_5xZ__"